export default __webpack_public_path__ + "static/media/my-profile.5afc0eee.svg";